import { render, staticRenderFns } from "./ToccaVinoProducts.vue?vue&type=template&id=bce587d8&"
import script from "./ToccaVinoProducts.vue?vue&type=script&lang=js&"
export * from "./ToccaVinoProducts.vue?vue&type=script&lang=js&"
import style0 from "./ToccaVinoProducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports